import React from 'react';

export function RechargeIcon() {
  return (
    <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.6665 14.1668H4.33317V15.8335H7.6665V14.1668Z" fill="#111111" />
      <path d="M0.166504 4.16683V15.8335C0.166504 17.6744 1.65889 19.1668 3.49984 19.1668H8.49984C10.3408 19.1668 11.8332 17.6744 11.8332 15.8335V4.16683C11.8332 2.32588 10.3408 0.833496 8.49984 0.833496H3.49984C1.65889 0.833496 0.166504 2.32588 0.166504 4.16683ZM3.49984 2.50016H8.49984C9.42031 2.50016 10.1665 3.24635 10.1665 4.16683V15.8335C10.1665 16.754 9.42031 17.5002 8.49984 17.5002H3.49984C2.57936 17.5002 1.83317 16.754 1.83317 15.8335V4.16683C1.83317 3.24635 2.57936 2.50016 3.49984 2.50016Z" fill="#111111" />
    </svg>
  );
}
